import http from "../../../utils/HttpUtils";

function transTree(dictTree, transRule = {
    "dictCode": "key",
    "dictName": "title"
}) {
    //转换逻辑
    dictTree.forEach((el) => {
        for (let key in transRule) {
            if (el.hasOwnProperty(key)) {
                el[transRule[key]] = el[key];
            }
        }
        if (el.children && el.children.length > 0) {
            transTree(el.children);
        }
    })
    return dictTree;
}

//字典接口服务
class DictService {
    //新建字典
    static async insert(data) {
        const apiUrl = "/base/dict/insertDict";
        return await http.post(apiUrl, data);
    }

    //修改自带你
    static async update(data) {
        const apiUrl = "/base/dict/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询字典信息
    static async findOne(id) {
        const apiUrl = `/base/dict/findDictsByCode/${id}`;
        return await http.get(apiUrl);
    }

    //查询字典树
    static async listTree() {
        const apiUrl = "/base/dict/findTree";
        let dictTree = await http.get(apiUrl);
        //数据转换
        transTree(dictTree);
        return dictTree;
    }

    //根据ID删除字典信息
    static async deleteOne(id) {
        const apiUrl = `/base/dict/delete/${id}`;
        return await http.get(apiUrl);
    }

    //根据ID删除字典信息
    static async generateID(pid) {
        const apiUrl = `/base/commDict/generateID`;
        return await http.get(apiUrl, { params: { pid } });
    }
}

export default DictService;